/* eslint-disable @typescript-eslint/camelcase */
import React, { useState } from 'react';
import { BmsTag } from '../../../hooks/useProductTags';
import * as Style from './styles';

// TODO Import types from next js
interface PricingFormProps {
  actualPrice: { CAD: number; USD: number };
  tripVariation: any;
  ardaPricing: any[];
  productTags: BmsTag[];
  onValueChange: (value: any) => void;
  key: any;
}

// TODO Import this function from next js utils
const numberWithCommas = (number: number): string => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const PricingForm = ({
  actualPrice,
  tripVariation,
  ardaPricing,
  onValueChange,
  productTags,
}: PricingFormProps) => {
  const variationArdaPrice = Array.isArray(ardaPricing) ? ardaPricing?.find(price => price.variation_id === tripVariation.id) : null;
  const [inputPrice, setInputPrice] = useState<any>({
    variation_id: tripVariation.id,
    season_start_on: variationArdaPrice?.season_start_on,
    season_end_on: variationArdaPrice?.season_end_on,
    pax_price_cad: variationArdaPrice?.pax_price_cad,
    pax_price_usd: variationArdaPrice?.pax_price_usd,
  });

  const setValue = (val: any, prop: string) => {
    const newVal = { ...inputPrice, [prop]: val };
    setInputPrice(newVal);
    onValueChange(cleanValues(newVal));
  };

  const cleanValues = (obj: any) => {
    Object.keys(obj).map((prop: any) => {
      // eslint-disable-next-line no-param-reassign
      obj[prop] = obj[prop] ? obj[prop] : '';
      return prop;
    });
    return obj;
  };
  const product = productTags.find(product => product.id === tripVariation.package_product_tag_id);
  return (
    <Style.PricingWrapper>
      <Style.Table>
        <thead>
          <tr>
            <th colSpan={2} scope="colgroup">
              BMS
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="heading">Trip Class:</td>
            <td>
              <input disabled value={product?.name || 'Base'} />
            </td>
          </tr>
          <tr>
            <td className="heading">Season start on:</td>
            <td>
              <input disabled value={tripVariation.season_start_on} />
            </td>
          </tr>
          <tr>
            <td className="heading">Season end on:</td>
            <td>
              <input disabled value={tripVariation.season_end_on} />
            </td>
          </tr>

          <tr>
            <td className="heading">Pax Price CDN$</td>
            <td>
              <input disabled value={numberWithCommas(Number((actualPrice?.CAD / 2).toFixed(2)))} />
            </td>
          </tr>
          <tr>
            <td className="heading">Pax Price USD$</td>
            <td>
              <input disabled value={numberWithCommas(Number((actualPrice?.USD / 2).toFixed(2)))} />
            </td>
          </tr>
        </tbody>
      </Style.Table>
      <Style.Table>
        <thead>
          <tr>
            <th colSpan={2} scope="colgroup">
              Website
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input disabled value={product?.name || 'Comfort'} />
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="text"
                value={inputPrice.season_start_on}
                placeholder="yyyy-mm-dd"
                maxLength={10}
                onChange={e => setValue(e.target.value, 'season_start_on')}
              />
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="text"
                value={inputPrice.season_end_on}
                placeholder="yyyy-mm-dd"
                maxLength={10}
                onChange={e => setValue(e.target.value, 'season_end_on')}
              />
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="number"
                value={inputPrice.pax_price_cad}
                placeholder="000.00"
                onChange={e => setValue(e.target.value, 'pax_price_cad')}
              />
            </td>
          </tr>
          <tr>
            <td>
              <input
                type="number"
                value={inputPrice.pax_price_usd}
                placeholder="000.00"
                onChange={e => setValue(e.target.value, 'pax_price_usd')}
              />
            </td>
          </tr>
        </tbody>
      </Style.Table>
    </Style.PricingWrapper>
  );
};

export default PricingForm;
